/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".questionnaire-title-layout[_ngcontent-%COMP%]{\n  padding: 0.3rem;\n  font-size: 0.3rem;\n  color: #4A4A4A;\n  font-weight: bold;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-title/component.questionnaire-title.css.shim.ngstyle.js.pre-build-optimizer.js